import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";
import defaultProfile, { asyncRoute } from "@/game_profiles/default";
import { commonMenuItems } from "@/game_profiles/common";
import { MenuItem } from "./types";

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  // Replace default status page with Deadlock-specific one
  menu[0].items[0] = new MenuItem(
    "",
    menu[0].items[0].icon,
    asyncRoute(() => import("../components/views/status/deadlock/DeadlockStatus.vue")),
  );
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "ConfSection", props: { name: "deadlock_gameplay" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
  hasActivePlayers: false,
  statusPageConfig: {
    showRconPort: false,
    showQueryPort: false,
    showFtp: true,
  },
});
